import { call, put } from 'redux-saga/effects';

import { request } from '!core/api';
import { logoutSlice } from '»components/Auth';
import { navigate } from '»utils/navigation';

export const handleSagaError = function* (error) {
  if (error[0].code === '401') {
    navigate('/');
    yield call(request.clearHeaders);
    yield put(
      logoutSlice.actions.logoutSuccess({
        showAlert: true,
        hasInvalidToken: true,
      }),
    );
    return true;
  }

  return false;
};
